import { createAlertAction } from 'store/alerts';

import { FETCH_KPI_HISTORY, FETCH_DASHBOARD_KPI, EXPORT_DASHBOARD_EXCEL } from './types';

export const fetchKpiHistory = createAlertAction(FETCH_KPI_HISTORY);
export const fetchDashboardKpi = createAlertAction(FETCH_DASHBOARD_KPI);
export const exportDashboardExcel = createAlertAction(EXPORT_DASHBOARD_EXCEL);
